export const RECEIPT_LABELS = Object.freeze({
  titleKo: '온라인 신용카드 매출전표',
  titleEn: 'Online Credit Card Sales Slip',
  storeInfo: '공급자 정보 Store Info',
  pspInfo: '결제솔루션사 정보 PSP Info',
  pgInfo: '결제대행사 정보 PG Info',
});

export const RECEIPT_BRAND_NAME =
  process.env.REACT_APP_MERCHANT_BRAND_NAME?.trim() || '유앤미케어';

export const RECEIPT_CARD_SMS_NOTICE =
  `본 거래와관련된 카드사 문자정보는 "${RECEIPT_BRAND_NAME}"로 발송이 됩니다.`;
